import React from 'react';
import { Avatar, Box, Button, Divider, Paper, Stack, Typography } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PhonelinkLockOutlinedIcon from '@mui/icons-material/PhonelinkLockOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

function SecurityHighlight({ icon, title }: { icon: React.ReactNode; title: string }) {
    return (
        <Paper variant="outlined" sx={{ flex: '1 1 90px', minWidth: 90, p: 1.5, textAlign: 'center' }}>
            <Avatar sx={{ bgcolor: 'action.hover', mx: 'auto', mb: 1 }}>{icon}</Avatar>
            <Typography variant="caption" color="text.secondary" display="block" align="center">
                {title}
            </Typography>
        </Paper>
    );
}

export default function TwoFactorFirstTimeStep({ next }: { next: CallableFunction }) {
    const __ = (window as any).__ ? ((window as any).__ as (text: string) => string) : (text: string) => text;

    return (
        <Box>
            <Stack alignItems="center" sx={{ mb: 3 }}>
                <Avatar
                    sx={{
                        width: 88,
                        height: 88,
                        bgcolor: 'primary.main',
                        boxShadow: 2,
                    }}
                >
                    <ShieldOutlinedIcon sx={{ fontSize: 48 }} />
                </Avatar>
            </Stack>
            <Stack direction="row" spacing={1.5} useFlexGap flexWrap="wrap" sx={{ mb: 3 }}>
                <SecurityHighlight icon={<LockOutlinedIcon color="primary" />} title={__('Ochrona konta')} />
                <SecurityHighlight icon={<PhonelinkLockOutlinedIcon color="primary" />} title={__('Kod 2FA')} />
                <SecurityHighlight
                    icon={<VerifiedUserOutlinedIcon color="primary" />}
                    title={__('Weryfikacja tożsamości')}
                />
            </Stack>
            <Typography sx={{ mb: 2 }} variant="body2" color="text.secondary">
                {__(
                    'Zadbaj o lepszą ochronę swojego konta. Nawet jeśli ktoś pozna Twoje hasło, dodatkowy krok weryfikacji powstrzyma go przed zalogowaniem się. To prosta i skuteczna bariera dla niepowołanych osób.'
                )}{' '}
                {__('Swoimi preferencjami możesz zarządzać w dowolnym momencie w sekcji "Ustawienia użytkownika".')}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Stack alignItems="center">
                <Button variant="contained" onClick={() => next()} startIcon={<ShieldOutlinedIcon />}>
                    {__('Włącz weryfikację dwuetapową (2FA)')}
                </Button>
            </Stack>
        </Box>
    );
}
